import { Tracer as LightstepTracer } from 'lightstep-tracer';
import * as opentracing from 'opentracing';
import { hexToIntString, intToHexString } from './util';
const OT_TRACE_ID_CHARS = 32;
export default class StackdriverTracer extends LightstepTracer {
    inject(spanContext, format, carrier) {
        LightstepTracer.prototype.inject.call(this, spanContext, format, carrier);
        if (format !== opentracing.FORMAT_HTTP_HEADERS &&
            format !== opentracing.FORMAT_TEXT_MAP) {
            return;
        }
        const traceGuid = spanContext.traceGUID();
        const spanGuid = carrier['ot-tracer-spanid'];
        const traceGuidForHeader = traceGuid.padEnd(OT_TRACE_ID_CHARS, '0');
        const spanGuidForHeader = hexToIntString(spanGuid);
        const traceValue = `${traceGuidForHeader}/${spanGuidForHeader};o=1`;
        delete carrier['ot-tracer-sampled'];
        delete carrier['ot-tracer-spanid'];
        delete carrier['ot-tracer-traceid'];
        carrier['X-Cloud-Trace-Context'] = traceValue;
    }
    extract(format, carrier) {
        const lightstepCarrier = Object.assign({}, carrier);
        const xCloudTraceContext = lightstepCarrier['X-Cloud-Trace-Context'];
        if (xCloudTraceContext) {
            const [traceGuidForHeader, spanGuidForHeader,] = xCloudTraceContext.replace(';o=1', '').split('/');
            lightstepCarrier['ot-tracer-traceid'] = traceGuidForHeader.substr(0, OT_TRACE_ID_CHARS);
            lightstepCarrier['ot-tracer-spanid'] = intToHexString(spanGuidForHeader);
            lightstepCarrier['ot-tracer-sampled'] = 'true';
        }
        return LightstepTracer.prototype.extract.call(this, format, lightstepCarrier);
    }
}
//# sourceMappingURL=Tracer.js.map